export interface Category {
  slug: string;
  name: string;
  short: string;
  subtitle: string;
  description: string;
  icon: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  status: string;
  year: string;
  rating: number;
  genres: string[];
  tags: string[];
  synopsis: string;
  reason: string;
  cover: string;
  coverAlt: string;
}

export const categories: Category[] = [
  {
    slug: "must-watch",
    name: "必看榜单",
    short: "必看",
    subtitle: "入坑必看 · 口碑盖章",
    description: "无论入坑多久都不该错过的经典之作，由全球读者口碑长期检验的必看漫画榜单。",
    icon: "ri-trophy-line",
  },
  {
    slug: "high-rated",
    name: "高分漫画",
    short: "高分",
    subtitle: "评分封神 · 高能全程",
    description: "评分长期高居前列、剧情与作画都经得起推敲的高分漫画精选。",
    icon: "ri-medal-line",
  },
  {
    slug: "hidden-gems",
    name: "冷门佳作",
    short: "冷门",
    subtitle: "遗珠宝藏 · 人少也好看",
    description: "热度不高但质量惊人的冷门佳作，专治「口味刁钻」的老读者。",
    icon: "ri-sparkling-line",
  },
  {
    slug: "checklist",
    name: "补番清单",
    short: "补番",
    subtitle: "年度清单 · 一次看个够",
    description: "整理成册的补番清单，按主题打包推荐，告别「不知道看什么」的漫荒时刻。",
    icon: "ri-list-check-3",
  },
];

export const comics: Comic[] = [
  {
    id: "haizei",
    title: "海贼王",
    author: "尾田荣一郎",
    category: "must-watch",
    status: "连载中",
    year: "1997",
    rating: 9.4,
    genres: ["冒险", "热血", "友情"],
    tags: ["王道热血", "宏大世界观", "少年漫标杆"],
    synopsis:
      "少年路飞吃下橡胶果实，立志成为海贼王，与伙伴们踏上伟大航路的冒险。超过二十年的连载，构筑出辽阔而浪漫的世界观，是无数读者的青春起点。",
    reason:
      "作为连载多年的王道冒险巨作，它把伙伴情谊、梦想与自由讲得淋漓尽致，是入坑少年漫绕不开的必看之作。",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20anime%20manga%20cover%20illustration%20of%20a%20cheerful%20young%20pirate%20captain%20in%20a%20straw%20hat%20with%20his%20crew%20aboard%20a%20sailing%20ship%2C%20adventurous%20spirit%2C%20warm%20tropical%20sunset%2C%20bold%20orange%20red%20and%20teal%20palette%2C%20clean%20background%2C%20dynamic%20shonen%20adventure%20manga%20style%2C%20high%20detail&width=600&height=800&seq=comic-haizei&orientation=portrait",
    coverAlt: "海贼王 冒险漫画封面插画",
  },
  {
    id: "guimie",
    title: "鬼灭之刃",
    author: "吾峠呼世晴",
    category: "must-watch",
    status: "已完结",
    year: "2016",
    rating: 9.1,
    genres: ["战斗", "历史", "亲情"],
    tags: ["大正时代", "热血战斗", "亲情羁绊"],
    synopsis:
      "家人被鬼杀害的少年炭治郎，为让变成鬼的妹妹变回人类而加入鬼杀队。故事以大正时代为背景，讲述斩鬼之路上的悲欢与羁绊。",
    reason:
      "节奏明快、情感真挚，篇幅精炼不注水，是近年最容易被「一口气看完」的必看热血番。",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20anime%20manga%20cover%20illustration%20of%20a%20swordsman%20in%20traditional%20japanese%20haori%20holding%20a%20katana%20with%20water%20and%20flame%20effects%2C%20historical%20demon%20slayer%20fantasy%2C%20deep%20crimson%20red%20and%20teal%20palette%2C%20dynamic%20ink%20brush%20strokes%2C%20clean%20background%2C%20high%20detail&width=600&height=800&seq=comic-guimie&orientation=portrait",
    coverAlt: "鬼灭之刃 斩鬼战斗漫画封面",
  },
  {
    id: "siwang",
    title: "死亡笔记",
    author: "大场鸫 / 小畑健",
    category: "must-watch",
    status: "已完结",
    year: "2003",
    rating: 9.2,
    genres: ["推理", "悬疑", "心理"],
    tags: ["智斗", "神作", "人性拷问"],
    synopsis:
      "天才高中生夜神月捡到一本「写上名字就会死亡」的笔记，决心以正义之名制裁罪犯，与追查他的侦探 L 展开旷日持久的智斗。",
    reason:
      "教科书级的智斗与道德思辨，剧情环环相扣，是悬疑推理爱好者必看的巅峰作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20anime%20manga%20cover%20illustration%20of%20a%20notebook%20with%20a%20stylized%20cover%20and%20a%20mysterious%20shinigami%20shadow%2C%20psychological%20thriller%20atmosphere%2C%20dark%20crimson%20and%20deep%20black%20palette%2C%20minimal%20composition%2C%20dramatic%20chiaroscuro%20lighting%2C%20high%20detail&width=600&height=800&seq=comic-siwang&orientation=portrait",
    coverAlt: "死亡笔记 悬疑推理漫画封面",
  },
  {
    id: "gang",
    title: "钢之炼金术师",
    author: "荒川弘",
    category: "high-rated",
    status: "已完结",
    year: "2001",
    rating: 9.6,
    genres: ["奇幻", "冒险", "哲理"],
    tags: ["全篇无槽点", "等价交换", "神作"],
    synopsis:
      "为让母亲复活而进行禁忌人体炼成的兄弟俩，付出惨痛代价后踏上寻找贤者之石的旅程，探索「等价交换」背后的真理与人性。",
    reason:
      "结构工整、主题深刻、结局收束完美，被公认为「没有缺点的漫画」，高分榜单的常驻冠军。",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20anime%20manga%20cover%20illustration%20of%20a%20young%20blond%20alchemist%20standing%20beside%20a%20towering%20steel%20armored%20companion%2C%20glowing%20golden%20transmutation%20circles%20and%20sparks%2C%20epic%20dark%20fantasy%20atmosphere%2C%20warm%20amber%20and%20burnt%20orange%20palette%20with%20deep%20ink%20shadows%2C%20bold%20dramatic%20composition%2C%20clean%20minimal%20background%2C%20high%20detail&width=600&height=800&seq=comic-gang&orientation=portrait",
    coverAlt: "钢之炼金术师 炼金术奇幻漫画封面",
  },
  {
    id: "paiqiu",
    title: "排球少年",
    author: "古馆春一",
    category: "high-rated",
    status: "已完结",
    year: "2012",
    rating: 9.5,
    genres: ["运动", "青春", "热血"],
    tags: ["团队成长", "运动番天花板", "燃"],
    synopsis:
      "身高不占优势却热爱排球的小个子日向翔阳，与天才二传影山飞雄组成的搭档，带领乌野高中一路冲击全国大赛。",
    reason:
      "没有超能力、只有扎实的战术与热血，把团队运动讲得真实动人，是运动番里口碑最好的一部。",
    cover:
      "https://readdy.ai/api/search-image?query=Dynamic%20anime%20manga%20cover%20illustration%20of%20a%20determined%20young%20volleyball%20player%20mid-jump%20spiking%20the%20ball%2C%20bright%20gymnasium%20lighting%2C%20energetic%20orange%20and%20teal%20accents%2C%20motion%20lines%2C%20clean%20warm%20background%2C%20energetic%20sports%20shonen%20style%2C%20high%20detail&width=600&height=800&seq=comic-paiqiu&orientation=portrait",
    coverAlt: "排球少年 运动漫画封面",
  },
  {
    id: "jojo",
    title: "JOJO的奇妙冒险",
    author: "荒木飞吕彦",
    category: "high-rated",
    status: "连载中",
    year: "1987",
    rating: 9.3,
    genres: ["动作", "奇幻", "热血"],
    tags: ["跨代传承", "独特美学", "波纹/替身"],
    synopsis:
      "以乔斯达家族为中心，跨越数代人的宿命对决。从波纹气功到替身使者，荒木用奇诡的想象力构筑出极具辨识度的热血世界。",
    reason:
      "脑洞大开的能力设定与独特美学风格，前卫大胆，是不可复制的另类高分神作。",
    cover:
      "https://readdy.ai/api/search-image?query=Flamboyant%20anime%20manga%20cover%20illustration%20of%20a%20muscular%20hero%20in%20a%20dramatic%20pose%20with%20a%20mysterious%20ghostly%20stand%20figure%20behind%2C%20bold%20fashion%2C%20dramatic%20lighting%2C%20gold%20and%20crimson%20palette%20with%20deep%20black%20shadows%2C%20extravagant%20action%20manga%20style%2C%20high%20detail&width=600&height=800&seq=comic-jojo&orientation=portrait",
    coverAlt: "JOJO的奇妙冒险 动作漫画封面",
  },
  {
    id: "lanse",
    title: "蓝色时期",
    author: "山口飞翔",
    category: "hidden-gems",
    status: "连载中",
    year: "2017",
    rating: 9.0,
    genres: ["艺术", "青春", "成长"],
    tags: ["美术生", "自我追寻", "真实细腻"],
    synopsis:
      "成绩优秀却内心空虚的高中生矢口八虎，被一幅画触动后毅然走上美术之路，在艺术学院的残酷竞争中追寻自我。",
    reason:
      "把「热爱与天赋」讲得真实而克制，角色成长极具代入感，是被低估的成长佳作。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20slice%20of%20life%20anime%20manga%20cover%20illustration%20of%20a%20young%20art%20student%20with%20a%20paintbrush%20and%20canvas%20among%20a%20gallery%20of%20colorful%20paintings%2C%20soft%20morning%20light%2C%20calm%20emotional%20art%20style%2C%20warm%20cream%20and%20indigo%20tones%2C%20clean%20background%2C%20high%20detail&width=600&height=800&seq=comic-lanse&orientation=portrait",
    coverAlt: "蓝色时期 艺术成长漫画封面",
  },
  {
    id: "tianguo",
    title: "天国大魔境",
    author: "石黑正数",
    category: "hidden-gems",
    status: "连载中",
    year: "2018",
    rating: 8.9,
    genres: ["科幻", "悬疑", "冒险"],
    tags: ["双线叙事", "末世", "伏笔回收"],
    synopsis:
      "在被怪物蹂躏的末世日本，少年少女踏上寻找「天国」的旅程；而封闭学院里的孩子们，也在一步步揭开世界的真相。",
    reason:
      "双线叙事的伏笔回收堪称精妙，悬念层层递进，是近年最出色的末世科幻之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20anime%20manga%20cover%20illustration%20of%20two%20characters%20crossing%20a%20ruined%20future%20cityscape%20with%20mysterious%20monsters%2C%20post%20apocalyptic%20sci-fi%20adventure%2C%20teal%20and%20amber%20palette%20with%20deep%20shadows%2C%20cinematic%20composition%2C%20clean%20background%2C%20high%20detail&width=600&height=800&seq=comic-tianguo&orientation=portrait",
    coverAlt: "天国大魔境 末世科幻漫画封面",
  },
  {
    id: "shashou",
    title: "杀手寓言",
    author: "南胜久",
    category: "hidden-gems",
    status: "连载中",
    year: "2014",
    rating: 8.8,
    genres: ["动作", "喜剧", "都市"],
    tags: ["反差萌", "硬核作画", "黑色幽默"],
    synopsis:
      "被称为「寓言」的天才杀手，被组织要求隐藏实力过一年普通生活，在东京的市井日常里演绎爆笑又硬核的双面人生。",
    reason:
      "打斗作画扎实硬朗，日常反差笑点密集，节奏与爽感并存的都市喜剧神作。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylish%20anime%20manga%20cover%20illustration%20of%20a%20calm%20stoic%20hitman%20in%20a%20suit%20with%20subtle%20comic%20humor%2C%20urban%20japanese%20city%20night%20background%2C%20warm%20neon%20and%20deep%20ink%20palette%2C%20clean%20composition%2C%20action%20comedy%20manga%20style%2C%20high%20detail&width=600&height=800&seq=comic-shashou&orientation=portrait",
    coverAlt: "杀手寓言 都市动作喜剧漫画封面",
  },
  {
    id: "jianjie",
    title: "间谍过家家",
    author: "远藤达哉",
    category: "checklist",
    status: "连载中",
    year: "2019",
    rating: 8.9,
    genres: ["喜剧", "日常", "间谍"],
    tags: ["温馨家庭", "反差萌", "全年龄"],
    synopsis:
      "为执行任务，顶级间谍「黄昏」临时组建了一个家庭：能读心的女儿、顶尖杀手的妻子。三个身怀秘密的人，演绎温馨爆笑的伪装家庭日常。",
    reason:
      "把间谍、超能力与家庭日常巧妙融合，搞笑又治愈，是全家都能一起看的轻快作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20anime%20manga%20cover%20illustration%20of%20a%20cheerful%20family%20of%20three%20with%20a%20spy%20father%20little%20telepath%20girl%20and%20assassin%20mother%2C%20warm%20comedy%20tone%2C%20bright%20peach%20orange%20and%20teal%20palette%2C%20clean%20friendly%20background%2C%20wholesome%20slice%20of%20life%20manga%20style%2C%20high%20detail&width=600&height=800&seq=comic-jianjie&orientation=portrait",
    coverAlt: "间谍过家家 温馨喜剧漫画封面",
  },
  {
    id: "xiari",
    title: "夏日重现",
    author: "田中靖规",
    category: "checklist",
    status: "已完结",
    year: "2017",
    rating: 9.0,
    genres: ["悬疑", "惊悚", "轮回"],
    tags: ["时间循环", "烧脑", "悬念拉满"],
    synopsis:
      "为参加青梅竹马葬礼回到故乡岛屿的主角，发现小岛被诡异「影子」缠身。死亡后时间会回溯，他必须一次次重复夏天，揭开真相。",
    reason:
      "时间循环与悬疑氛围结合得天衣无缝，伏笔与反转层出不穷，一口气看完欲罢不能。",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20anime%20manga%20cover%20illustration%20of%20a%20seaside%20summer%20town%20at%20dusk%20with%20a%20mysterious%20girl%2C%20time%20loop%20mystery%20thriller%2C%20warm%20sunset%20and%20deep%20indigo%20palette%2C%20cinematic%2C%20clean%20background%2C%20high%20detail&width=600&height=800&seq=comic-xiari&orientation=portrait",
    coverAlt: "夏日重现 悬疑轮回漫画封面",
  },
  {
    id: "dianjuren",
    title: "电锯人",
    author: "藤本树",
    category: "checklist",
    status: "连载中",
    year: "2018",
    rating: 8.9,
    genres: ["动作", "黑暗", "奇幻"],
    tags: ["疯批脑洞", "暴力美学", "神转折"],
    synopsis:
      "为还清债务、过着贫苦生活的少年电次，与电锯恶魔合体成为「电锯人」，被神秘组织收编对抗各种恶魔。剧情疯狂又浪漫，无法预测。",
    reason:
      "藤本树不受束缚的想象力与神级分镜，让每一话都充满惊喜与意外，是新一代现象级作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20anime%20manga%20cover%20illustration%20of%20a%20young%20man%20with%20chainsaw%20attachments%20in%20a%20dark%20city%20street%2C%20violent%20dark%20action%2C%20crimson%20red%20and%20charcoal%20black%20palette%2C%20neon%20shadows%2C%20bold%20dynamic%20manga%20style%2C%20high%20detail&width=600&height=800&seq=comic-dianjuren&orientation=portrait",
    coverAlt: "电锯人 黑暗动作漫画封面",
  },
];

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.category === slug);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}